<template>
  <el-dialog
    title=""
    :visible.sync="isShowModel"
    top="0"
    :close-on-click-modal="false"
    width="480px"
    :show-close="false"
    custom-class="consumeBox"
  >
    <div class="dialog-head">
      <span>功能使用提示</span>
      <fm-button
        @click="handleClose"
        type="info"
        size="mini"
        text
        icon="icon-model-close"
      ></fm-button>
    </div>
    <div class="dialog-content">
      <div class="dialog-tips">
        <img :src="$utils.getPng('icon11')" />
        <span class="ext">{{ curtailInfo.msg1 }}</span>
      </div>
      <p class="desc">{{ curtailInfo.msg2 }}</p>
      <div class="btns" v-show="curtailInfo.msgType != '4'">
        <span class="primaryBtn" @click="confirm()">确认</span>
        <span class="plainBtn" @click="handleClose">取消</span>
      </div>
      <div class="btns btns2" v-show="curtailInfo.msgType == '4'">
        <span class="primaryBtn" @click="govip()">开通/升级会员</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowModel: Boolean,
    curtailInfo: Object,
  },
  data() {
    return {}
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    confirm() {
      this.$emit('confirmDo')
    },
    govip() {
      this.$emit('govip')
    },
  },
}
</script>

<style></style>
